var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOther = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 2,
  viewBox: "0 0 14 2",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 1C2 1.55228 1.55228 2 1 2C0.447716 2 0 1.55228 0 1C0 0.447716 0.447716 0 1 0C1.55228 0 2 0.447716 2 1Z",
  fill: "#E00C69"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 1C8 1.55228 7.55228 2 7 2C6.44772 2 6 1.55228 6 1C6 0.447716 6.44772 0 7 0C7.55228 0 8 0.447716 8 1Z",
  fill: "#E00C69"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13 2C13.5523 2 14 1.55228 14 1C14 0.447716 13.5523 0 13 0C12.4477 0 12 0.447716 12 1C12 1.55228 12.4477 2 13 2Z",
  fill: "#E00C69"
})));
export { SvgOther as ReactComponent };
export default __webpack_public_path__ + "assets/icons/other.3da413.svg";